import { Pipe, PipeTransform } from '@angular/core';
import { ProductGridPlaceholder } from '@app/custom/features/rrs-product-listing/model/rrs-product-listing.model';
import { BREAKPOINT, BreakpointService } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'rrsPlpItemImageSrc',
})
export class RrsPlpItemImageSrcPipe implements PipeTransform {
  constructor(private breakpointService: BreakpointService) {}

  transform(value: ProductGridPlaceholder): Observable<string> {
    return this.breakpointService.isDown(BREAKPOINT.md).pipe(
      map((isMobile: boolean) => {
        if (isMobile && value?.image_file_mobile) {
          return value.image_file_mobile?.url;
        }
        return value.image_file?.url;
      })
    );
  }
}
